import {
  IntegrationSettingsAccountLevelForm,
  IntegrationSettingsForm,
  IntegrationSettingsLevel,
  IntegrationSettingsLocationLevelForm,
  IntegrationSettingsUserLevelForm,
} from "../types";

export const formatIntegrationSettingsFormDataToPayload = (
  integrationName: string,
  formData: IntegrationSettingsForm
) => {
  return Object.keys(formData).reduce((acc: any, key) => {
    const integrationLevelSettings = Object.values(formData[key as IntegrationSettingsLevel] || {}) as
      | IntegrationSettingsUserLevelForm[]
      | IntegrationSettingsLocationLevelForm[]
      | IntegrationSettingsAccountLevelForm[];
    if (!integrationLevelSettings?.length) {
      return acc;
    }

    const levelSettings = integrationLevelSettings
      .filter(
        item =>
          item.integrationSettingsValuesId ||
          Object.values(item.integrationSettingsValues || {}).some(item =>
            Array.isArray(item) ? item.length > 0 : !!item
          )
      ) // to exclude non touched rows
      .map(item => ({
        integrationName,
        integrationSettingsValuesId: item.integrationSettingsValuesId,
        integrationSettingsValues: item.integrationSettingsValues,
        userProfileId: "userProfileId" in item ? item.userProfileId : undefined,
        locationId: "locationId" in item ? item.locationId : undefined,
      }));
    return [...acc, ...levelSettings];
  }, []);
};
